import React, { createContext, useContext, useState, useCallback } from 'react';

const ClassFilterContext = createContext(null);

export function ClassFilterProvider({ children }) {
  const [classFilter, setClassFilter] = useState(() => {
    // Restore from sessionStorage for session persistence
    return sessionStorage.getItem('fraime_class_filter') || 'all';
  });

  const setClass = useCallback((classId) => {
    const value = classId || 'all';
    setClassFilter(value);
    sessionStorage.setItem('fraime_class_filter', value);
  }, []);

  return (
    <ClassFilterContext.Provider value={{ classFilter, setClass }}>
      {children}
    </ClassFilterContext.Provider>
  );
}

export function useClassFilter() {
  return useContext(ClassFilterContext);
}
